import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import { useSurveyResponses } from '@lifeomic/phc-web-toolkit/src/hooks/useSurveyResponses';
// @ts-expect-error SurveyList is a JS module.
import SurveyList from './SurveyList';

type SurveyListContainerProps = {
  patient: fhir.Patient;
  mrnConfig: unknown;
  isFetchingProjectSurveys: boolean;
  projectSurveys: fhir.Questionnaire[];
  hasMoreToLoad: boolean;
  loadMode: () => void;
};

const SurveyListContainer: React.FC<SurveyListContainerProps> = props => {
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search);
  const launchSurveyId =
    typeof query.launch === 'string' ? query.launch : undefined;
  const launchResponseId =
    typeof query.response === 'string' ? query.response : undefined;
  const {
    responses,
    hasFetchedResponses,
    fetchResponsesError,
    resetResponses,
  } = useSurveyResponses({
    patientId: props.patient.id,
  });
  const onLaunchConsumed = useCallback(() => {
    history.replace(location.pathname);
  }, [history, location.pathname]);

  return (
    <SurveyList
      {...props}
      responses={responses}
      areResponsesReady={hasFetchedResponses}
      responsesError={!!fetchResponsesError}
      resetResponses={resetResponses}
      launchSurveyId={launchSurveyId}
      launchResponseId={launchResponseId}
      onLaunchConsumed={onLaunchConsumed}
    />
  );
};

export default SurveyListContainer;
